import React from "react";
import { Input, Form } from "antd";
import { AutoResizeTextArea } from "../../../../../../components/AutoResizeTextArea";
import styles from "./messageInput.scss";
import { requiredField } from "../../../../../../models/formValidator";

const rules = [
  requiredField(null, "Unesite svoju poruku"),
  {
    max: 500,
    message: "Poruka ne može biti dulja od 500 znakova."
  }
];

const MessageInput = ({ form }) => {
  const { getFieldDecorator } = form;

  return (
    <Form.Item className={styles.container}>
      {getFieldDecorator("message", {
        rules
      })(
        <AutoResizeTextArea
          // @ts-ignore
          size="large"
          className={styles.textArea}
          placeholder={"Unesite poruku"}
        />
      )}
    </Form.Item>
  );
};

export default MessageInput;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/MessageInput/index.tsx